import { PrefixLogger } from './prefix_logger'

export class ClassLogger extends PrefixLogger {
  constructor (className, sink = null) {
    super(`[${className}]`, sink)
  }
}
